import { NgModule } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DcsButtonComponent } from './dcs-button/dcs-button.component';
import { DcsCheckboxComponent } from './dcs-checkbox/dcs-checkbox.component';
import { DcsRadioComponent } from './dcs-radio/dcs-radio.component';
import { DcsTextFieldComponent } from './dcs-text-field/dcs-text-field.component';
import { CommonModule } from '@angular/common';
import { DcsVerifiedEmailField } from './dcs-verified-email-field/dcs-verified-email-field.component';
@NgModule({
  declarations: [
    DcsButtonComponent,
    DcsCheckboxComponent,
    DcsRadioComponent,
    DcsTextFieldComponent,
    DcsVerifiedEmailField,
  ],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    DcsButtonComponent,
    DcsCheckboxComponent,
    DcsRadioComponent,
    DcsTextFieldComponent,
    DcsVerifiedEmailField,
  ],
})
export class UiModule {}
